import { render, staticRenderFns } from "./ClipboardTextField.vue?vue&type=template&id=5dde2e8e"
import script from "./ClipboardTextField.vue?vue&type=script&lang=js"
export * from "./ClipboardTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports